import { BREAKPOINTS, DASHBOARD_CARD_PER_PAGE_COUNT, DASHBOARD_MAX_CAROUSEL_PAGES,ACCEPT_STATUS_TEXT,ACCEPT_ORG_USER_STATUS_TEXT,REJECT_STATUS_TEXT,REJECT_ORG_USER_STATUS_TEXT } from '../constants/constants';
import { VIEW_TYPE } from 'src/constants/constants';
/** Method to get cards displayed per carousel page */
export const getCardsPerPage = (width: number): number => {
    if (width < BREAKPOINTS.XS) {
        return DASHBOARD_CARD_PER_PAGE_COUNT.XS;
    }
    else if (width < BREAKPOINTS.SM) {
        return DASHBOARD_CARD_PER_PAGE_COUNT.SM;
    }
    else if (width < BREAKPOINTS.MD) {
        return DASHBOARD_CARD_PER_PAGE_COUNT.MD;
    }
    else if (width < BREAKPOINTS.LG) {
        return DASHBOARD_CARD_PER_PAGE_COUNT.LG;
    }
    else if (width >= BREAKPOINTS.LG) {
        return DASHBOARD_CARD_PER_PAGE_COUNT.XL;
    }
    else {
        return 0;
    }
};

/** Method to get number of carousel pages */
export const getMaxNumOfCarouselPages = (width: number): number => {
    if (width < BREAKPOINTS.XS) {
        return DASHBOARD_MAX_CAROUSEL_PAGES.XS;
    }
    else if (width < BREAKPOINTS.SM) {
        return DASHBOARD_MAX_CAROUSEL_PAGES.SM;
    }
    else if (width < BREAKPOINTS.MD) {
        return DASHBOARD_MAX_CAROUSEL_PAGES.MD;
    }
    else if (width < BREAKPOINTS.LG) {
        return DASHBOARD_MAX_CAROUSEL_PAGES.LG;
    }
    else if (width >= BREAKPOINTS.LG) {
        return DASHBOARD_MAX_CAROUSEL_PAGES.XL;
    }
    else {
        return 0;
    }
};
export const getStatusCount = (type: string, data: any) => {
    switch (type) {
        case 'inprogress':
            const accepted = data[ACCEPT_STATUS_TEXT] ? data[ACCEPT_STATUS_TEXT] : 0;
            return accepted;
        case 'completed':
            const acceptedOrgUser = data[ACCEPT_ORG_USER_STATUS_TEXT] ? data[ACCEPT_ORG_USER_STATUS_TEXT] : 0;
            const rejectedOrgUser = data[REJECT_ORG_USER_STATUS_TEXT] ? data[REJECT_ORG_USER_STATUS_TEXT] : 0;
            const rejectedAll = data[REJECT_STATUS_TEXT] ? data[REJECT_STATUS_TEXT] : 0;
            return acceptedOrgUser + rejectedOrgUser + rejectedAll;
        default:
            return 0;
    }
}
  
/** Method to format currency - adds comma */
export const currencyFormatter = (amount: number) => {
    let parts = ('' + amount).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
};

export const isNumeric=(value:string)=> {
    return Number(value)/10;
}

/** Formats currency to Number Notation format
 * Ex: currencyNumberNotationFormatter ('10448500') returns 10.45M
 */
export const currencyNumberNotationFormatter = (amount: number) => {
    // Nine Zeroes for Billions
    return amount >= 1.0e+9
    ? (+(amount / 1.0e+9).toFixed(2)) + 'B'
    // Six Zeroes for Millions 
    : amount >= 1.0e+6
    ? (+(amount / 1.0e+6).toFixed(2)) + 'M'
    : amount >= 1.0e+3
    ? (+(amount / 1.0e+3).toFixed(2)) + 'K'
    : amount;
};

export const getTargetImpact = (targetValue: number | undefined, opportunityValue: number) =>  {
    let targetImpact = 0;
    if (targetValue) {
        targetImpact = opportunityValue / targetValue;
    }
    return (Math.ceil(+(targetImpact.toFixed(2)) * 100));
};

export const isOverviewDashboard = (overviewViewType: string) => {
    if (overviewViewType === VIEW_TYPE.ALL_ANOMALIES_VIEW || 
        overviewViewType === VIEW_TYPE.OVERDUE_ANOMALIES_VIEW || 
        overviewViewType === VIEW_TYPE.ACTION_ASSIGNMENT_VIEW || 
        overviewViewType === VIEW_TYPE.USER_ACTIVITY || 
        overviewViewType === VIEW_TYPE.TREND_USER_ACTIVITY || 
        overviewViewType === VIEW_TYPE.PENDING_ACTIONS||
        overviewViewType === VIEW_TYPE.AUDIT_REJECTIONS_VIEW)
        return true;
    else
        return false;
}


